"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Promise = require("promise-polyfill");
window.Promise =
    window.Promise || Promise.default || Promise;
//# sourceMappingURL=promise.js.map